import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getReqDutyInfo } from "../../../redux/actions";
import { SelectStaffDataType } from "../../../types/TableTypes";
import addKey from "../../../utility/addKeys";
import formatAmount from "../../../utility/formatAmount";
import TableWithCollapse from "../../component/TableWithCollapse";

function StaffSelectionTable(props) {
  const { req_staff_info, onRowClick } = props;
  //state Info for step 1
  const [staffInfo, setStaffInfo] = useState<SelectStaffDataType[]>();

  useEffect(() => {
    if (req_staff_info) {
      setStaffInfo(addKey(req_staff_info));
    }
  }, [req_staff_info]);

  const staff_columns: ColumnsType<SelectStaffDataType> = [
    { title: "Staff Name", dataIndex: "STAFF_NAME", key: "STAFF_NAME" },
    { title: "Staff No", dataIndex: "STAFF_NO", key: "STAFF_NO" },
    {
      title: "Amount",
      dataIndex: "AMOUNT",
      key: "AMOUNT",
      render: (value, record, index) => {
        return formatAmount(value);
      },
    },
    {
      title: "Pending Request",
      dataIndex: "PENDING_REQUEST",
      key: "PENDING_REQUEST",
    },
  ];

  return (
    <TableWithCollapse
      data={staffInfo}
      columns={staff_columns}
      onRowClick={onRowClick}
      hideCol={[]}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    //req_staff_info: state.data.req_staff_info
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchReqDutyInfo: (staffNo, staffInfo, isApprover) => {
    return dispatch(getReqDutyInfo(staffNo, staffInfo, isApprover));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffSelectionTable);
